// 持有数量角标（EP-008-S6 / GDD 03 §②-5 / ⑥-S8 D1/D2）。
// count >= 2 才显示（count === 1 不显示）；与 RarityDots 物理分离（D1）。
// 数量数字属于「已获得回顾信息」，非 B1 审计子树（away/reveal），故可显示。
interface CountBadgeProps {
  count: number;
}

export function CountBadge({ count }: CountBadgeProps) {
  if (count < 2) return null;
  return (
    <span className="count-badge" aria-hidden="true">
      ×{count}
    </span>
  );
}
